
function SdOrderStatusCtrl(TranslationService) {
    var ctrl = this;

    ctrl.translation = TranslationService.getActiveTranslation();
    this.margin = '100';

    ctrl.customClass = function (item) {
        return 'status-card Status' + item;
    };
}

SdOrderStatusCtrl.$inject = ['TranslationService'];

seedWebApp.component('sdOrderStatus', {
    controller: SdOrderStatusCtrl,
    bindings: {
        loading: '<',
        statusId: '<',
        ngModel: '<',
        editable: '<'
    },
    templateUrl: '/SPA/components/sd-order-status.html' + seedWebApp.buildVersion
});